import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  baseHttpService = inject(BaseHttpService);

  constructor() { }  

  usdExchangeRate(currency: string): Observable<number> {
    return this.baseHttpService.get<number>('/currency/usd-exchange-rate/' + currency);
  }
  
  treasuryDefinedCurrencyConversionRateUsdAndNgn(year: number, month: number): Observable<number> {
    return this.baseHttpService.get<number>('/currency/conversion-rate-usd-ngn' + '/'  + year + '/' + month);
  }
}
